import type { DataLayerEvent } from '../model/types';

type DataLayerWindow = Window & {
  dataLayer?: DataLayerEvent[];
};

export function pushDataLayer(event: DataLayerEvent): boolean {
  if (typeof window === 'undefined') return false;

  try {
    const dataLayerWindow = window as DataLayerWindow;
    dataLayerWindow.dataLayer ??= [];
    dataLayerWindow.dataLayer.push(event);

    return true;
  } catch {
    return false;
  }
}
